import store from "./store";

function deltaTime() {
  return store.engine.getDeltaTime() / 1000;
}

export { deltaTime };
